// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PlatformLink-module__link___Q41xQ {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 7px 10px;
  width: 100%;
  background: #fafafa;
  border: 1px solid #e4e4e7;
  border-radius: 6px;
  text-decoration: none;
  color: #18181b;
  cursor: pointer;
  transition: border-color 0.15s, color 0.15s, background-color 0.15s;
  text-align: left;
}

.PlatformLink-module__link___Q41xQ:hover {
  border-color: #a1a1aa;
}

.PlatformLink-module__link___Q41xQ:focus-visible {
  outline: 2px solid #18181b;
  outline-offset: 2px;
}

.PlatformLink-module__disabled___jaSiv {
  cursor: default;
  opacity: 0.7;
}

.PlatformLink-module__disabled___jaSiv:hover {
  border-color: #e4e4e7;
}

.PlatformLink-module__badge___bunC1 {
  width: 22px;
  height: 22px;
  border-radius: 4px;
  background: #18181b;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.PlatformLink-module__badgeText___t_p7S {
  font-size: 10px;
  font-weight: 700;
  color: #fafafa;
  font-family: "IBM Plex Mono", monospace;
}

.PlatformLink-module__meta___elKaF {
  flex: 1;
}

.PlatformLink-module__title___Qwkvu {
  font-size: 11px;
  font-weight: 600;
}

.PlatformLink-module__mrn___kUZux {
  font-size: 10px;
  color: #a1a1aa;
  margin-left: 6px;
  font-family: "IBM Plex Mono", monospace;
}

.PlatformLink-module__arrow___lN9gq {
  font-size: 13px;
  color: #a1a1aa;
}`, "",{"version":3,"sources":["webpack://./src/pages/CareOrchestration/components/PlatformLink/PlatformLink.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,WAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,qBAAA;EACA,cAAA;EACA,eAAA;EACA,mEAAA;EACA,gBAAA;AACF;;AAEA;EACE,qBAAA;AACF;;AAEA;EACE,0BAAA;EACA,mBAAA;AACF;;AAEA;EACE,eAAA;EACA,YAAA;AACF;;AAEA;EACE,qBAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;AACF;;AAEA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,uCAAA;AACF;;AAEA;EACE,OAAA;AACF;;AAEA;EACE,eAAA;EACA,gBAAA;AACF;;AAEA;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,uCAAA;AACF;;AAEA;EACE,eAAA;EACA,cAAA;AACF","sourcesContent":[".link {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 7px 10px;\n  width: 100%;\n  background: #fafafa;\n  border: 1px solid #e4e4e7;\n  border-radius: 6px;\n  text-decoration: none;\n  color: #18181b;\n  cursor: pointer;\n  transition: border-color 0.15s, color 0.15s, background-color 0.15s;\n  text-align: left;\n}\n\n.link:hover {\n  border-color: #a1a1aa;\n}\n\n.link:focus-visible {\n  outline: 2px solid #18181b;\n  outline-offset: 2px;\n}\n\n.disabled {\n  cursor: default;\n  opacity: 0.7;\n}\n\n.disabled:hover {\n  border-color: #e4e4e7;\n}\n\n.badge {\n  width: 22px;\n  height: 22px;\n  border-radius: 4px;\n  background: #18181b;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.badgeText {\n  font-size: 10px;\n  font-weight: 700;\n  color: #fafafa;\n  font-family: 'IBM Plex Mono', monospace;\n}\n\n.meta {\n  flex: 1;\n}\n\n.title {\n  font-size: 11px;\n  font-weight: 600;\n}\n\n.mrn {\n  font-size: 10px;\n  color: #a1a1aa;\n  margin-left: 6px;\n  font-family: 'IBM Plex Mono', monospace;\n}\n\n.arrow {\n  font-size: 13px;\n  color: #a1a1aa;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"link": `PlatformLink-module__link___Q41xQ`,
	"disabled": `PlatformLink-module__disabled___jaSiv`,
	"badge": `PlatformLink-module__badge___bunC1`,
	"badgeText": `PlatformLink-module__badgeText___t_p7S`,
	"meta": `PlatformLink-module__meta___elKaF`,
	"title": `PlatformLink-module__title___Qwkvu`,
	"mrn": `PlatformLink-module__mrn___kUZux`,
	"arrow": `PlatformLink-module__arrow___lN9gq`
};
module.exports = ___CSS_LOADER_EXPORT___;
